module.exports = __webpack_public_path__ + "bfa591dd3a8b39e0a9f7c4db42419c02.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-28.png
// module id = 2606
// module chunks = 0